import { UserRole } from 'shared/types/userRole';

export function filterOutSuperAdmin(user: { role: UserRole }): boolean {
  return user.role !== UserRole.superAdmin;
}
